import "core-js/modules/es6.array.reduce";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.assign";

var _extends = Object.assign || function (t) {
  for (var n = 1; n < arguments.length; n++) {
    var o = arguments[n];

    for (var e in o) {
      Object.prototype.hasOwnProperty.call(o, e) && (t[e] = o[e]);
    }
  }

  return t;
},
    _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
  return typeof t;
} : function (t) {
  return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
},
    _this = void 0,
    trackEventWhenReady = function trackEventWhenReady() {
  for (var t = arguments.length, n = Array(t), o = 0; o < t; o++) {
    n[o] = arguments[o];
  }

  return window.analytics.ready(function () {
    return window.analytics.track.apply(_this, n);
  });
},
    trackPageWhenReady = function trackPageWhenReady() {
  for (var t = arguments.length, n = Array(t), o = 0; o < t; o++) {
    n[o] = arguments[o];
  }

  return window.analytics.ready(function () {
    return window.analytics.page.apply(_this, n);
  });
},
    identifyWhenReady = function identifyWhenReady() {
  for (var t = arguments.length, n = Array(t), o = 0; o < t; o++) {
    n[o] = arguments[o];
  }

  return window.analytics.ready(function () {
    return window.analytics.identify.apply(_this, n);
  });
},
    logPageLoad = function logPageLoad(t) {
  var n = t.referrer,
      o = t.delay;
  setTimeout(function () {
    var t = {
      title: document.title,
      referrer: n,
      path: window.location.pathname,
      search: window.location.search,
      url: window.location.href
    };
    trackPageWhenReady(t.title, t);
  }, o || 0);
},
    logFirstPageLoad = function logFirstPageLoad() {
  var t = "object" === _typeof(window.history.state) ? window.history.state : null;
  window.history.replaceState(_extends({}, t, {
    referrer: document.referrer
  }), ""), logPageLoad({
    referrer: document.referrer
  });
},
    configurePageLoadTracking = function configurePageLoadTracking() {
  var t = window.history.pushState;
  window.history.pushState = function () {
    var n = window.location.origin + window.location.pathname + window.location.search,
        o = [_extends({}, arguments.length <= 0 ? void 0 : arguments[0], {
      referrer: n
    }), arguments.length <= 1 ? void 0 : arguments[1], arguments.length <= 2 ? void 0 : arguments[2]];

    try {
      logPageLoad({
        referrer: n
      });
    } catch (t) {
      console.error(t);
    }

    return t.apply(window.history, o);
  }, window.addEventListener("popstate", function () {
    var t = (window.history.state || {}).referrer;
    logPageLoad({
      referrer: (void 0 === t ? "" : t) || "",
      delay: 50
    });
  }, !1);
},
    isEmptyObject = function isEmptyObject(t) {
  return "object" === (void 0 === t ? "undefined" : _typeof(t)) && !Object.keys(t).length;
},
    analyticsStartup = function analyticsStartup(t) {
  var n = t.integrations,
      o = t.options,
      e = void 0 === o ? {} : o,
      i = t.autorun,
      r = void 0 === i || i;
  isEmptyObject(n) ? console.error("analyticsStartup has failed! Your analytic integrations are missing!") : (window.analytics.initialize(n, e), !1 !== r && (logFirstPageLoad(), configurePageLoadTracking()));
},
    bootstrapAnalytics = function bootstrapAnalytics(t) {
  var n = window.onload;
  window.onload = "function" == typeof n ? function () {
    analyticsStartup(t);

    for (var o = arguments.length, e = Array(o), i = 0; i < o; i++) {
      e[i] = arguments[i];
    }

    n.apply(this, e);
  } : function () {
    return analyticsStartup(t);
  };
},
    checkForMissingFunctions = function checkForMissingFunctions() {
  var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
  return arguments[1].reduce(function (n, o) {
    return "function" != typeof t[o] ? "" + n + o + " ," : n;
  }, "");
},
    initAnalytics = function initAnalytics() {
  var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
      n = t.analytics,
      o = t.integrations,
      e = t.options,
      i = void 0 === e ? {} : e,
      r = t.autorun,
      a = void 0 === r || r;
  if ("object" !== (void 0 === n ? "undefined" : _typeof(n)) || "object" !== (void 0 === o ? "undefined" : _typeof(o))) throw new Error("Analytics is not logging! You must initialize analytics with the correct params.");
  var c = checkForMissingFunctions(n, ["ready", "track", "page", "identify"]);
  if (c.length) throw new Error("Analytics is not logging! Expected analytics to contain " + c + " function(s).");
  var s = checkForMissingFunctions(n.Integrations, Object.keys(o));
  s.length && (console.warn("Your analytics is missing the integrations you specified in your settings@ Expected analytics to contain " + s + " integration(s)."), console.warn("The missing integration(s) will not work without being included in your analytics.js.")), window.analytics = n, bootstrapAnalytics({
    integrations: o,
    options: i,
    autorun: a
  });
};

export { trackEventWhenReady, trackPageWhenReady, identifyWhenReady, initAnalytics };